import React from 'react';
import HelpIcon from '@tradera/blueprint/theme/icons2/help.svg?jsx';

const InfoTooltip = ({ displayText }) => {
    return (
        <span className="tooltip_container tooltip-focus">
            <HelpIcon className="icon ml-1" />
            <span className="tooltip tooltip-southwest">{displayText}</span>
        </span>
    );
};

export default InfoTooltip;
